import { render, staticRenderFns } from "./refView.vue?vue&type=template&id=ecb64ca6"
import script from "./refView.vue?vue&type=script&lang=js"
export * from "./refView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports